module.exports = __webpack_public_path__ + "static/media/HCMM312.3ea0e100.jpg";